import HubAboutTherapyPage from './HubAboutTherapyPage'

export default HubAboutTherapyPage
